import React, { useState } from "react";
import "../styles/CallToAction.css";

const CallToAction = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const sendToWhatsApp = () => {
        const phoneNumber = "+6285773745006"; // Nomor WhatsApp
        const text = `Halo, saya ${name}.\nEmail: ${email}\nPesan: ${message}`;
        const whatsappUrl = `https://wa.me/${phoneNumber.replace("+", "")}?text=${encodeURIComponent(text)}`;
        window.open(whatsappUrl, "_blank");
    };

    return (
        <div className="cta-container">
            <div className="cta-wrapper"> 
                {/* Google Maps */}
                <div className="map-container">
                    <iframe 
                        title="Lokasi Kami"
                        // ✅ PERUBAHAN: Ganti URL src iframe Google Maps di sini
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15860.84244762783!2d106.8600570871582!3d-6.366784099999989!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69ed48502a0b5f%3A0x8b3071078865910d!2sSistem%20Pemantauan%20Depot%20Air%20(Depot%20Air%20Cerdas)!5e0!3m2!1sid!2sid!4v1752831189200!5m2!1sid!2sid" 
                        width="100%" 
                        height="100%" 
                        style={{ border: "0" }} 
                        allowFullScreen="" 
                        loading="lazy" 
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div>

                {/* Formulir Hubungi Kami */}
                <div className="cta-content">
                    <h2>Hubungi Kami</h2>
                    <p>Isi formulir di bawah ini untuk menghubungi kami melalui WhatsApp.</p>

                    <div className="contact-form">
                        <input 
                            type="text" 
                            placeholder="Nama Anda" 
                            value={name} 
                            onChange={(e) => setName(e.target.value)}
                        />
                        <input 
                            type="email" 
                            placeholder="Email Anda" 
                            value={email} 
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <textarea 
                            placeholder="Pesan Anda" 
                            value={message} 
                            onChange={(e) => setMessage(e.target.value)}
                        ></textarea>
                        <button onClick={sendToWhatsApp} className="whatsapp-btn">Kirim via WhatsApp</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CallToAction;